import $ from 'jquery';

const contact = () => {
    const $profileHeader = $('.s-page-profile-header');

    if ($profileHeader.length === 0) return;

    const $contactNav = $('.contact-nav');

    $contactNav.click(e => {
        const $this = $(e.currentTarget);

        $this.parent().toggleClass('show');
    });
};

$(() => {
    contact();
});



// WEBPACK FOOTER //
// ./src/sections/page-profile-header/s-page-profile-header.js